export function BrandLogo() {
  return (
    <img
      className="brand-logo"
      src="/brand/logo-landscape-290.png"
      srcSet="/brand/logo-landscape-290.png 290w, /brand/logo-landscape-580.png 580w"
      sizes="128px"
      width={580}
      height={327}
      alt="24talk"
    />
  );
}
